'use strict';
var ENVIRONMENT = require('../internals/environment');

module.exports = ENVIRONMENT === 'NODE';



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/environment-is-node.js
// module id = 102
// module chunks = 0